import React from "react";
import useGame from "../../hooks/useGame";

export default function Topics({ id, ...props }) {
  const game = useGame(id);
  return <h1>Topics for {game.name}</h1>;
}
